import { render, staticRenderFns } from "./WColumn.vue?vue&type=template&id=91553d70&scoped=true&"
import script from "./wColumn.ts?vue&type=script&lang=ts&"
export * from "./wColumn.ts?vue&type=script&lang=ts&"
import style0 from "./WColumn.vue?vue&type=style&index=0&id=91553d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91553d70",
  null
  
)

export default component.exports